import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import Router from '@ember/routing/router';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import ContactModel from 'donor-elf-web/models/contact';

export class AddContactItem {
  constructor(contact: ContactModel) {
    this.contact = contact;
  }

  contact: ContactModel;
  @tracked selected = false;
}

export default class JournalAddIndexController extends Controller {
  @service declare contactsCache: any;
  @service declare fundsService: any;
  @service declare journalService: any;
  @service declare router: Router;
  @service declare store: Store;

  @tracked q = '';
  @tracked group = '';
  @tracked saving = false;

  get contactItems(): Array<AddContactItem> {
    return this.model.contactItems as Array<AddContactItem>;
  }

  get filterApplied() {
    return isPresent(this.q) && this.q.length >= 2;
  }

  get filteredContactItems() {
    let filteredItems = this.contactItems;
    if (this.filterApplied) {
      let filteredContactIds: any = {};
      this.contactsCache.search(this.q).forEach((x: ContactModel) => {
        filteredContactIds[x.id] = true;
      });
      filteredItems = filteredItems.filter((x) => {
        return filteredContactIds[x.contact.id] || false;
      });
    }
    if (isPresent(this.group)) {
      let groupContactIds: any = {};
      this.contactsCache.groupContacts[this.group].contacts.forEach((x) => {
        groupContactIds[x.id] = true;
      });
      filteredItems = filteredItems.filter(
        (x) => groupContactIds[x.contact.id],
      );
    }
    return filteredItems;
  }

  get allFilteredContactItemsSelected() {
    return this.filteredContactItems.find((x) => x.selected !== true) == null;
  }

  get selectedContactItems() {
    return this.contactItems.filter((x) => x.selected);
  }

  get availableGroupOptions() {
    return [
      {
        val: '',
        label: 'Filter by Group',
      },
    ].concat(
      this.contactsCache.sortedGroups.map((x: string) => {
        return { val: x, label: x };
      }),
    );
  }

  @action
  templateWillDestroy() {
    this.q = '';
    this.group = '';
    this.saving = false;
  }

  @action
  handleSearchInput(e: any) {
    this.q = e.target.value;
  }

  @action
  handleSelectButtonClicked() {
    let checkedValue = this.allFilteredContactItemsSelected ? false : true;
    this.filteredContactItems.forEach((item) => {
      item.selected = checkedValue;
    });
  }

  @action
  toggleSelected(item: AddContactItem) {
    item.selected = !item.selected;
  }

  @action
  handleGroupChange(e: any) {
    this.group = e.target.value;
  }

  @action
  handleGroupClicked(group: string) {
    this.q = '';
    this.group = group;
  }

  @action
  async save() {
    let selectedContactItems = this.selectedContactItems;
    if (selectedContactItems.length === 0) {
      this.router.transitionTo('funds.fund.journals.journal.index');
      return;
    }
    this.saving = true;
    await this.fundsService.confirmValidFundToken();
    let record = this.store.createRecord('journal-add-contact', {
      journalId: this.model.journalInfo.journal.id,
      contactIds: selectedContactItems.map((x) => x.contact.id),
    });
    await record.save();
    await this.journalService.load({ forceReload: true });
    this.router.transitionTo('funds.fund.journals.journal');
  }
}
